import type { TenantConfig } from '@/types/TenantConfig'

export const vanartgallery: TenantConfig = {
  themeOptions: {
    dialog: {
      headerBackground: '#000000',
      headerTextColor: '#ffffff',
      headerIconColor: '#ffffff',
      headerBorder: '0',
    },
    mobileFooter: {
      cartButtonBorder: '1px solid #000000',
      cartButtonIconColor: '#000000',
      textColor: '#000000',
      priceTextColor: '#000000',
    },
  },
  logo: 'assets/vanartgallery/static/logo.svg',
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/vanartgallery/static/images/success.jpg',
        mobile: 'assets/vanartgallery/static/images/success-mobile.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
  i18nOverrides: {
    en: {
      loginForm: {
        lastNameLabel: 'Member Last Name',
      },
    },
  },
  teaserImageSize: {
    width: 320,
  },
}
